import React, { useState } from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { Check as CheckIcon, ContentCopy as CopyIcon } from '@mui/icons-material';

/** Monospace ID with a copy button. `short` shows the first 8 characters; the full value is copied. */
export const CopyId: React.FC<{ value: string; short?: boolean; label?: string }> = ({ value, short, label }) => {
  const [copied, setCopied] = useState(false);
  const copy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard can be unavailable on insecure origins; the value is still selectable.
    }
  };
  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25, minWidth: 0 }}>
      {label && (
        <Typography component="span" variant="body2" color="text.secondary" sx={{ mr: 0.5 }}>
          {label}
        </Typography>
      )}
      <Tooltip title={short ? value : ''}>
        <Typography component="span" variant="body2" sx={{ fontFamily: 'monospace', wordBreak: 'break-all' }}>
          {short ? value.slice(0, 8) : value}
        </Typography>
      </Tooltip>
      <Tooltip title={copied ? 'Copied' : 'Copy'}>
        <IconButton size="small" onClick={copy} sx={{ p: 0.25 }}>
          {copied ? <CheckIcon sx={{ fontSize: 14 }} color="success" /> : <CopyIcon sx={{ fontSize: 14 }} />}
        </IconButton>
      </Tooltip>
    </Box>
  );
};
